import { createOidc, useOidcStore } from "vue3-oidc";

import { WebStorageStateStore } from "oidc-client-ts";
import router from "@/router";
import store from "~/store/index";

const oidcSettings = {
  authority: undefined,
  scope: "openid email profile offline_access eduperson_entitlement eduperson_scoped_affiliation voperson_external_id",
  client_id: undefined,
  client_secret: undefined,
  redirect_uri: `${origin}/oidc-callback`,
  silent_redirect_uri: `${origin}/silent-callback.html`,
  response_type: "code",
  loadUserInfo: true,
  automaticSilentRenew: true,
  monitorSession: false,
  userStore: new WebStorageStateStore({
    store: window.localStorage,
  }),
  extraQueryParams: {
    prompt: "consent",
  },
};

export async function runAuth() {
  oidcSettings.authority = await store.getters.oidc_endpoint;
  oidcSettings.client_id = await store.getters.oidc_client_id;
  createOidc({
    oidcSettings: oidcSettings,
    auth: false,
    events: {
      addAccessTokenExpired: async () => {
        console.log("accessTokenExpired");
      },
      addAccessTokenExpiring: () => {
        console.log("accessTokenExpiring");
      },
      addUserSessionChanged: () => {
        console.log("userSessionChanged");
      },
      addUserLoaded: (user) => {
        console.log("signed in " + user.profile.name);
      },
      addUserSignedOut: () => {
        console.log("signed out");
      },
    },
  });
}

const state = useOidcStore();

export async function hasValidSession() {
  if (window.location.href.includes("oidc-callback")) {
    return;
  }
  if (window.location.href.includes("mijn/community/")) {
    const community = window.location.href.split("mijn/community/")[1];
    if (community.endsWith("/")) {
      localStorage.setItem("post_login_redirect", community.slice(0, -1));
    } else {
      localStorage.setItem("post_login_redirect", community);
    }
  }
  const user = await state.state.value.userManager?.getUser();
  if (user) {
    console.log(`Found session for user ${user?.profile.sub}`);
    if (user.expired) {
      console.log("Session expired, trying to login again");
      await signout();
      await state.state.value.userManager?.signinRedirect();
    }
    await store.dispatch("setUser", user);
    console.log("expires " + new Date(user.expires_at * 1000));
  } else {
    if (window.location.href.includes("mijn/community/")) {
      console.log("No session, user not logged in, trying silent login");
      state.state.value.userManager.signinRedirect();
    }
  }
}

export async function signout() {
  state.state.value.user = null;
  state.state.value.userManager?.removeUser();
}
